import React from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { AlertLoudIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/AlertLoudIcon'
import { AttentionIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/AttentionIcon'
import { Link } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/link/Link'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { useCapacityUpdateFlow } from '../../hooks/useCapacityUpdateFlow'

const Container = styled.View({
  alignItems: 'flex-end',
  flexDirection: 'column',
})

const Row = styled.View(({ theme }) => ({
  alignItems: 'center',
  flexDirection: 'row',
  gap: theme.spacing['4px'],
}))

const CaseloadCounter: React.FC = () => {
  const { colors } = useTheme()
  const { acceptingCount, isVisible, openUpdateFlow, modals } = useCapacityUpdateFlow()

  if (!isVisible) {
    return null
  }

  const showAlert = acceptingCount === 0
  const showAttention = acceptingCount === 1

  let textColor = colors.textSecondary
  if (showAlert) {
    textColor = colors.textError
  } else if (showAttention) {
    textColor = colors.textWarning
  }

  return (
    <Container testID={tID('CaseloadCounter')}>
      <Row>
        {showAlert && <AlertLoudIcon fillColor={colors.iconError} testID={tID('CaseloadCounter-alert-icon')} />}
        {showAttention && (
          <AttentionIcon fillColor={colors.iconWarning} testID={tID('CaseloadCounter-attention-icon')} />
        )}
        <BodyText
          size={BodyTextSize.SMALL}
          color={textColor}
          text={
            <FormattedMessage
              defaultMessage='Accepting {count, plural, one {# new client} other {# new clients}} · <updateLink>Update</updateLink>'
              description='Counter showing how many new clients the provider is accepting'
              values={{
                count: acceptingCount,
                updateLink: () => (
                  <Link
                    text={
                      <FormattedMessage defaultMessage='Update' description='Link to open the capacity update modal' />
                    }
                    onPress={openUpdateFlow}
                    testID={tID('CaseloadCounter-update')}
                    size={BodyTextSize.SMALL}
                    underline
                  />
                ),
              }}
            />
          }
        />
      </Row>
      {modals}
    </Container>
  )
}

export default CaseloadCounter
